<div class="tAlignCenter dFlex flexDirColumn justifyContentCenter alignItemsCenter">
  <img src="/assets/images/session-expired-icon.png" alt="" />
  <h2 class="w100 marTop20">Still there? Your session is expiring soon</h2>
  <p class="w100 darkGreyT marBot40">
    For your security, your session will expire soon due to inactivity. To keep working, please choose
    <b>Continue session</b> below.
  </p>
  <div class="dFlex flexDirColumnRev alignItemsCenter">
    <button class="w300 withBorder btn outlined marTop20" (click)="logout()" type="button">Log out</button>

    <button class="w300 btn dropShadow" (click)="continueSession()" type="button">Continue session</button>
  </div>
</div>
